export default __webpack_public_path__ + "static/media/pm.8867ffbf.png";